
const GetNpsKpiReducer = (state = { type: 'LOADING_NPS_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NPS_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const CancelNpsKpiReducer = (state = { type: 'LOADING_NPS_CANCEL_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NPS_CANCEL_ACTION':
            return action
        default:
            return state
    }
}

const CancelWalkmeAccessReducer = (state = { type: 'LOADING_CANCEL_WALKME_ACCESS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CANCEL_WALKME_ACCESS_ACTION':
            return action
        default:
            return state
    }
}


export {
    GetNpsKpiReducer,
    CancelNpsKpiReducer,
    CancelWalkmeAccessReducer
}